// 自动生成，请勿手动修改

import { observer } from 'mobx-react'

import { ImgIcons } from './IconData'

export interface IconImgProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  src: keyof typeof ImgIcons
}

export const IconImage = observer(({ src, ...props }: IconImgProps) => {
  const icon = require(`../../assets/images/icons/${ImgIcons[src]}`)
  return <img draggable={false} src={icon} alt='' {...props} />
})